module.exports = __webpack_public_path__ + "static/media/customer-solution-3.40eca7b0.png";